const { makeStyles } = require('@material-ui/core')
import cuestionarioFondo from './assets/image/cuestionarioFondo.png'

const previewQuestionnaireStyles = makeStyles(theme => ({
   container: {
      background: `url(${cuestionarioFondo}) no-repeat center center fixed`,
      backgroundSize: 'cover',
      display: 'flex',
      // justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      height: '90vh'
   },
   form: {
      width: '100%'
   },
   containForm: {
      padding: '0 20px'
   },
   title: {
      width: '70%',
      alignSelf: 'start',
      margin: "0 auto",
      color: "white",
      marginTop: '6.3%',
      marginBottom: "20px",
      textTransform: "uppercase"
   },
   paper: {
      // height: '300px',
      width: '70%',
      // marginTop: '6.3%',
      // borderTop: '8px solid #3264DC',
      // boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflow: 'hidden'
      // padding: '2rem 3rem'
   },
   paperResults: {
      // height: '300px',
      width: '70%',
      flexDirection: 'column',
      alignItems: 'center',
      overflow: 'hidden',
      // padding: '2rem 3rem'
   },
   titleResults:{
      fontSize: '40px',
      color: '#1E57E1',
      margin: '5px'
   },
   subtitleResults:{
      fontSize: '12px',
      color: '#1E57E1',
      margin: '5px'
   },
   textResults:{
      fontSize: '16px',
      color: '#43496A',
      marginBottom: '10px'
   },
   textResultsSpan:{
      fontSize: '16px',
      fontWeight: 700,
      color: '#43496A',
      marginBottom: '10px'
   },
   imgResults:{
      width: '220px',
      height: '220px',
   },
   subtextResults:{
      fontSize: '14px',
      color: '#43496A',
      marginBottom: '10px'
   },
   buttonHome: {
      borderRadius: '100px',
      overflow: 'hidden',
      width: '70px',
      height: '70px',
      transition: 'transform .2s',
      '&:hover': {
         transform: 'scale(1.1)',
         cursor: 'pointer'
      }
   },
   buttonsNavigationsBox: {
      position: 'absolute',
      top: '15%',
      left: '9%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
   },
   iconArrowBack: {
      backgroundColor: '#1E57E1',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      color: '#FFFFFF',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '10px',
      cursor: 'pointer',
      transition: 'transform .2s',
      '&:hover': {
         transform: 'scale(1.1)'
      }
   },
   iconArrowBack2: {
      // position: 'relative',
      // left: '40',
      // top: '10%',
      justifySelf: 'flex-end !important',
      backgroundColor: '#1E57E1',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      color: '#FFFFFF',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '10px',
      cursor: 'pointer',
      transition: 'transform .2s',
      '&:hover': {
         transform: 'scale(1.1)'
      }
   },
   boxInfo: {
      backgroundColor: '#A7B0C61A',
      padding: '1rem 2rem',
      width: '100%'
   },
   boxLineDecoration: {
      display: 'flex',
      width: '100%',
      height: '10px',
      justifyContent: 'flex-end',
      padding: '0 3rem',
      backgroundColor: '#0F4C87'
   },
   boxFooterPaper: {
      width: '100%',
      display: 'flex',
      gap: '1rem',
      justifyContent: 'space-between',
      padding: '1rem',
      alignItems: 'center'
   },
   iconPincel: {
      marginBottom: '10px',
      backgroundColor: '#A7B0C61A',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      color: '#a7b0c6',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '10px',
      cursor: 'pointer',
      transition: 'transform .2s',
      '&:hover': {
         backgroundColor: '#ebf0fe',
         transform: 'scale(1.1)',
         color: '#1E57E1'
      }
   },
   itemAsnwerBox: {
      backgroundColor: '#A7B0C61A',
      padding: '.1rem .7rem ',
      borderRadius: '15px',
      width: '100%',
      display: 'flex',
      gap: '.7rem',
      cursor: 'pointer',
      transition: 'transform .2s',
      '&:hover': {
         backgroundColor: '#ebf0fe'
      }
   },
   boxButtonFotterNavigation: {
      display: 'flex',
      gap: '2rem'
   },
   buttonReadyAnswer: {
      '& .MuiButton-label': {
         // fontWeight: '400',
         padding: '0 2rem'
      },
      '& .MuiButton-startIcon ': {
         // justifyContent: 'initial',
         justifySelf: 'flex-start'
      }
   },
   root: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontSize: '13px'
   },
   boxItemSelect: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      // borderRadius: '10px',
      fontSize: '13px',
      width: '100%',
      height: '100%',
      padding: '1rem',
      margin: '0'
      // '&:hover': {
      //     background: '#3264DC0F 0% 0% no-repeat',
      //     color: '#3264DC'
      // }
   },
   formControlSelect: {
      width: '50%',
      display: 'flex',
      minWidth: 120,
      gap: '12px',
      justifyContent: 'space-between',
      alignItems: 'center'
      // '&:not(:first-child)': {
      //     marginTop: '20px'
      // }
   },
   selectInput: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      justifyContent: 'space-between'
   },
   list: {
      padding: '10px',

      '& li': {
         margin: '5px 0',
         borderRadius: '5px',
         padding: '16px',
         '&:hover': {
            background: '#3264DC0F 0% 0% no-repeat',
            color: '#3264DC'
         }
      }
   }
}))

export default previewQuestionnaireStyles
